import { requests } from '.';
const MediaServices = {
    listFiles: (params) => requests().get('/medias/files/', { params }),
    listBackgrounds: (params) => requests().get('/medias/backgrounds', { params }),
    listTextures: (params) => requests().get('/medias/textures', { params }),
    createUploadSignedUrl: (params) => requests().post('/medias/files/', params),
    verifyFileUpload: (params) => requests().post('/medias/files/verify', params),
    createFolder: (params) => requests().post('/medias/folder', params),
    deleteObject: (params) => requests().delete(`/medias/${params.id}`, {
        params: {
            altId: params.altId,
            altType: params.altType,
        },
    }),
    renameObject: (params) => requests().post(`/medias/${params.id}`, {
        name: params.name,
        altId: params.altId,
        altType: params.altType,
    }),
    startMigration: (params) => requests().post(`/medias/migrate`, params),
    checkMigrationStatus: (params) => requests().get(`/medias/migration-status`, { params }),
    moveFile: (params) => requests().post(`/medias/move`, params),
    addFile: (params) => requests().post(`/medias/add`, params),
    initiateEncoding: (params) => requests().post(`/medias/encode`, params),
    getLocationUsage: (params) => requests().get(`/medias/location/usage`, { params }),
    getGroupedLocationUsage: (params) => requests().get(`/medias/grouped-usage/location`, { params }),
    deleteObjects: (params) => requests().put(`/medias/delete-files`, Object.assign({}, params)),
    moveFiles: (params) => requests().post(`/medias/move-files`, params),
    getSignedUrl: (params) => requests().get('/medias/get-signed-url', { params }),
    ensureFolderExists: (params) => requests().post('/medias/ensureFolderExists', params),
    /**
     * --------Google Drive API's---------
     */
    getGoogleDriveConnectionInfo: ({ locationId }) => requests().get(`/medias/drive/get-connection-info?locationId=${locationId}`),
    getGooglDriveInfo: ({ connectionId }) => requests().get(`/medias/drive/about?connectionId=${connectionId}`),
    fetchDriveFiles: params => requests().get('/medias/drive/files', { params }),
    fetchDriveFolders: params => requests().get('/medias/drive/folders', { params }),
    uploadDriveFile: (params, formData) => requests().post(`/medias/drive/upload?connectionId=${params.connectionId}&parentId=${params.parentId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }),
    createDriveFolder: (connectionId, params) => requests().post(`/medias/drive/create-folder?connectionId=${connectionId}`, params),
};
export default MediaServices;
